import { localestr } from "./utils";
//export const ENGINE_URL = 'engine.php'
//export const ENGINE_URL = 'https://cocktail.pp.ua/pos/engine.php'
//export const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
//export var ENGINE_URL = 'https://cocktail.local/cocktail-front/engine.php'
//  export var ENGINE_URL = "http://localhost/pos/engine.php";
//  export var REPORT_URL = "http://localhost/pos/report.php";
//  export var TERMINAL_URL = "http://localhost/pos/term.php";
export var ENGINE_URL = "https://cocktail-4.e-menu.in.ua/pos/engine.php";
export var REPORT_URL = "https://cocktail-4.e-menu.in.ua/pos/report.php";
export var TERMINAL_URL = "https://cocktail-4.e-menu.in.ua/pos/term.php";
//export var ENGINE_URL = "http://localhost:8000/engine.php";
//export var ENGINE_URL = 'https://cocktail-4.e-menu.in.ua/pos_stable/engine.php'
if (process.env.NODE_ENV === "production") ENGINE_URL = "engine.php";
if (process.env.NODE_ENV === "production") REPORT_URL = "report.php";
if (process.env.NODE_ENV === "production") TERMINAL_URL = "term.php";


export const PAY_TYPES = {
    "0": localestr("Готівкою"),
    "1": localestr("Карткою"),
    "2": localestr("Liqpay"),
    "3": localestr("QR код моно"),
    "4": localestr("Сертифікат"),
    "6": localestr("По перерахунку"),
};

// #1 VOLTEY 1
export const THEME_1 = {
  "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bg.svg), #E1CFE1`,
  "--navbar-bg-color": "#3B346B",
  "--navbar-tx-color": "#E1CFE1",

  "--black-tx-color": "#0C262E",
  "--dark-tx-color": "#0C262E",
  "--black-btn-color": "#0C262E",
  "--black-btn-tx-color": "#FFF",
  "--dark-btn-color": "#0C262E",

  /* folder */
  "--folder-border-color": "#0000",
  "--folder-bg-color": "#0C262E",
  "--folder-tx-color": "#FFF",

  /* item */
  "--item-bg-color": "#66569F",
  "--item-border-color": "#0000",
  "--item-tx-color": "#E1CFE1",

  /* active other user */
  "--tbl1-bg-color": "#3B346B",
  "--tbl1-border-color": "#0000",
  "--tbl1-tx-color": "#FFF",

  /* active current user */
  "--tbl2-bg-color": "#0C262E",
  "--tbl2-border-color": "#0000",
  "--tbl2-tx-color": "#FFF",

  "--toolbtn-bg-color": "#cbb9e8",
  "--toolbtn-tx-color": "#0C262E",

  "--modal-head-color": "#E1CFE1",
  "--modal-wnd-color": "#3B346B",
  "--modal-wnd-bg-color": "#E1CFE1",

  "--switch-on-color": "#0C262E",
  "--switch-off-color": "#FFF",
  "--switch-bg-color": "#66569F",

  "--menu-data-bg-color": "#E1CFE1",
  "--menu-data-border-color": "#0C262E",
  "--menu-data-tx-color": "#0C262E",
  "--menu-data-item-hover-bg-color": "#66569F",
  "--menu-data-item-hover-tx-color": "#E1CFE1",
};

export const THEME_2 = {
  '--background': `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bg.svg), #F6F3EC`,
  '--navbar-bg-color': '#3B346B',
  '--navbar-tx-color': '#E1CFE1',

  '--black-tx-color': '#0C262E',
  '--dark-tx-color': '#0C262E',
  '--black-btn-color': '#0C262E',
  '--black-btn-tx-color': '#FFF',
  '--dark-btn-color': '#0C262E',

  /* folder */
  '--folder-border-color': '#0000',
  '--folder-bg-color': '#66569F',
  '--folder-tx-color': '#FFF',

  /* item */
  '--item-bg-color': '#a198bf',
  '--item-border-color': '#0000',
  '--item-tx-color': '#FFF',

  /* active other user */
  '--tbl1-bg-color': '#66569F',
  '--tbl1-border-color': '#0000',
  '--tbl1-tx-color': '#FFF',

  /* active current user */
  '--tbl2-bg-color': '#b58e68',
  '--tbl2-border-color': '#0000',
  '--tbl2-tx-color': '#FFF',

  '--toolbtn-bg-color': '#E1CFE1',
  '--toolbtn-tx-color': '#0C262E',

  '--modal-head-color': '#F6F3EC',
  '--modal-wnd-color': '#66569F',
  '--modal-wnd-bg-color': '#F6F3EC',

  '--switch-on-color': '#0C262E',
  '--switch-off-color': '#FFF',
  '--switch-bg-color': '#a198bf',

  '--menu-data-bg-color': '#F6F3EC',
  '--menu-data-border-color': '#0C262E',
  '--menu-data-tx-color': '#0C262E',
  '--menu-data-item-hover-bg-color': '#a198bf',
  '--menu-data-item-hover-tx-color': '#F6F3EC',
};